module.exports = __webpack_public_path__ + "img/12angry-13.a947e1b7.jpg";